import { apiFetch } from '@ami/react/core';
import { InventoryItemFilter } from './inventoryItemFilter';
import { ProductDimension } from '../products/product';
const _baseEndPoint = 'inventory-items';
const _baseEndPointCustomers = 'inventory-items/customer-search';

export const InventoryItemCondition = {
  new: 'New',
  used: 'Used',
  demo: 'Demo',
};

export class InventoryItemConfig {
  constructor(item) {
    if (item) {
      this.condition = item.condition;
      this.paintColor = item.paintColor;
      this.minimumLeadTime = item.minimumLeadTime;
      this.availableOn = item.availableOn;
      this.units = item.units;
      this.notes = item.notes;
      this.isRestricted = item.isRestricted;
      this.restrictedReason = item.restrictedReason || '';
      this.isConsignment = item.isConsignment;
      this.consignmentDealerBranchId = item.consignmentDealerBranchId;
      this.consignmentDealerBranchName = item.consignmentDealerBranchName;
      this.preferredMakes = item.preferredMakes;
    } else {
      this.units = [];
      this.notes = '';
      this.paintColor = '';
      this.restrictedReason = '';
      this.isRestricted = false;
      this.isConsignment = false;
      this.consignmentDealerBranchId = null;
      this.consignmentDealerBranchName = '';
      this.preferredMakes = [];
    }
  }
}

export class InventoryItemViewModel extends InventoryItemConfig {
  constructor(item) {
    super(item);
    this.id = item.id;
    this.name = item.name;
    this.productGroupId = item.productGroupId;
    this.productOptions = item.productOptions;
    this.productId = item.productId;
    this.carrierId = item.carrierId;
    this.carrierName = item.carrierName;
    this.weightCategoryIds = item.weightCategoryIds;
    this.weightCategoryLabels = item.weightCategoryLabels;
    this.partNumber = item.partNumber;
    this.imageUrl = item.imageUrl;
    this.dimensions = item.dimensions.map((x) => new ProductDimension(x));
    this.leadTimeDays = item.leadTimeDays;
    this.machine = item.machine;
    this.sold = item.sold;
    this.inStock = item.inStock;
    this.thumb = item.thumb;
    this.lugging = item.lugging;
    this.availableQuantity = item.availableQuantity;
    this.preferredMakes = item.preferredMakes;
  }

  update() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'PUT', this);
  }

  delete() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'DELETE');
  }
}

export class InventoryItem extends InventoryItemConfig {
  constructor(item) {
    super(item);
    if (item) {
      this.id = item.id;
      this.name = item.name;
      this.productGroupId = item.productGroupId;
      this.productId = item.productId;
      this.productOptions = item.productOptions;
      this.attachmentPointId = item.attachmentPointId;
      this.carrierId = item.carrierId;
      this.weightCategoryIds = item.weightCategoryIds;
      this.partNumber = item.partNumber;
      this.luggingDetail = new InventoryItemLuggingDetail(item.luggingDetail);
      this.thumbDetail = new InventoryItemThumbDetail(item.thumbDetail);
      this.sold = item.sold;
      this.productCategoryId = item.productCategoryId; // Not persisted but needed in the creation component
      this.preferredMakes = item.preferredMakes;
      return;
    }
    this.productOptions = [];
    this.luggingDetail = new InventoryItemLuggingDetail();
    this.thumbDetail = new InventoryItemThumbDetail();
    this.sold = false;
    this.preferredMakes = [];
  }

  static async search(filter = new InventoryItemFilter(), page, isPublic) {
    filter.setPaginationParameters(page);
    filter.$orderby = 'Name asc';
    const result = await apiFetch(
      `${
        isPublic ? _baseEndPointCustomers : _baseEndPoint
      }?${filter.toQueryString()}`,
      'GET',
      null,
      null,
      isPublic
    );
    return result.map((x) => new InventoryItemViewModel(x));
  }

  static async getForExport(filter = new InventoryItemFilter()) {
    return await apiFetch(
      `${_baseEndPoint}/export/csv?${filter.toQueryString()}`
    );
  }

  static async getById(id) {
    const entity = await apiFetch(`${_baseEndPoint}/${id}`);
    return new InventoryItemViewModel(entity);
  }

  static create(item) {
    return apiFetch(_baseEndPoint, 'POST', item);
  }  
}

export class InventoryItemLuggingDetail {
  constructor(json) {
    if (json) {
      this.selectMachinePinUp = json.selectMachinePinUp;
      this.selectCouplerPartNumber = json.selectCouplerPartNumber;
      this.couplerPartNumber = json.couplerPartNumber;
      this.couplerType = json.couplerType;
      this.machinePinUpId = json.machinePinUpId;
      this.machinePinUpName = json.machinePinUpName;
      return;
    }
    this.selectMachinePinUp = false;
    this.selectCouplerPartNumber = false;
    this.couplerPartNumber = '';
    this.couplerType = null;
    this.machinePinUpId = null;
    this.machinePinUpName = '';
  }
}

export class InventoryItemThumbDetail {
  constructor(json) {
    if (json) {
      this.factoryMount = json.factoryMount;
      this.thumbTipRadius = json.thumbTipRadius;
      this.thumbClassId = json.thumbClassId;
      this.thumbClassName = json.thumbClassName;
      return;
    }
    this.factoryMount = false;
    this.thumbTipRadius = '';
    this.thumbClassId = null;
    this.thumbClassName = '';
  }
}